module.exports = __webpack_public_path__ + "img/triggerasmnt.0ef6631b.svg";